import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import 'semantic-ui-css/semantic.min.css'
import "react-select/dist/react-select.min.css";
import "./index.css";
import Main from "./components/main";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import { store } from "./store";
import Signin from "./components/auth/signin";
import RequireAuth from './components/auth/requireAuth';


export default class App extends Component {
	state = {
		authToken: "",
		center: { lat: 20.5937, lng: 78.9629 }
	};

	render() {
		
		return (
			<div>
				<Provider store={store}>
					<Router>
						<Switch>
							{/* <Route
								exact
								path="/"
								component={() => <div>No Auth Token Provided</div>}
							/> */}
							{/* <Route exact path="/token=:authToken" component={Main} /> */}
														<Route exact path="/map" component={RequireAuth(Main)} />
														<Route exact path="/" component={Signin} />
							{/* <Route
								exact
								path="/plano-frontend/token=:authToken"
								component={Main}
							/> */}
						</Switch>
					</Router>
				</Provider>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/v3/App.js